import { setDefaultStyle } from "apparatus/draw";
import { LIQUID_OPACITY_RANGE, P, Segments, SharedColors } from "apparatus/library/common";
import { Group, Path } from "paper";
import { setLiquidStyle } from "../../draw";
import { DEFAULT_LIQUID_DATA } from "../common";
/** Handle ratio to create a circular shape. */
export let CIRCULAR_RATIO = 0.55;
export class OsmosisTube {
    render(appearance) {
        // Length above the bend.
        const length = appearance.size * 2;
        const diameter = 30;
        let innerRadius = appearance.size;
        let outerRadius = innerRadius + diameter;
        const outerShell = new Path(uShapeSegment(outerRadius, length));
        const innerShell = new Path(uShapeSegment(innerRadius, length));
        setDefaultStyle(outerShell, innerShell);
        innerShell.reverse();
        const leftFluid = new Path(...innerShell.segments.slice(2).map(s => s.clone()), ...outerShell.segments.slice(0, 3).map(s => s.clone()));
        const rightFluid = new Path(...outerShell.segments.slice(2).map(s => s.clone()), ...innerShell.segments.slice(0, 3).map(s => s.clone()));
        // Choose levels on either side. Keep it below length.
        const rightLevel = appearance.rightLevel * length;
        const leftLevel = appearance.leftLevel * length;
        leftFluid.segments[2].point.y = -leftLevel;
        leftFluid.segments[3].point.y = -leftLevel;
        rightFluid.segments[2].point.y = -rightLevel;
        rightFluid.segments[3].point.y = -rightLevel;
        // Set colours.
        setLiquidStyle(leftFluid, appearance.leftColor, appearance.leftOpacity);
        setLiquidStyle(rightFluid, appearance.rightColor, appearance.rightOpacity);
        // Add a barrier.
        const barrier = new Path.Line(P(0, innerRadius), P(0, outerRadius));
        barrier.withStroke(4.0, SharedColors.stroke);
        barrier.dashArray = [3, 3];
        const graphic = new Group([leftFluid, rightFluid, barrier, innerShell, outerShell]);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            watermark: graphic.bounds.bottomCenter,
        };
    }
}
OsmosisTube.properties = {
    label: "Osmosis Tube",
    defaultAppearance: {
        size: 60,
        leftColor: SharedColors.defaultLiquid,
        leftOpacity: DEFAULT_LIQUID_DATA.alpha,
        leftLevel: 0.5,
        rightColor: SharedColors.defaultLiquid,
        rightOpacity: DEFAULT_LIQUID_DATA.alpha,
        rightLevel: 0.5,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 40, max: 80
        },
        { spec: "header", icon: "tint", header: "Left liquid" },
        {
            spec: "color", key: "leftColor", label: "Colour",
            opacity: { key: "leftOpacity", range: LIQUID_OPACITY_RANGE }
        },
        {
            spec: "slider", key: "leftLevel", label: "Level",
            min: 0.0, max: 1.0, step: 0.01
        },
        { spec: "header", icon: "tint", header: "Right liquid" },
        {
            spec: "color", key: "rightColor", label: "Colour",
            opacity: { key: "rightOpacity", range: LIQUID_OPACITY_RANGE }
        },
        {
            spec: "slider", key: "rightLevel", label: "  Level",
            min: 0.0, max: 1.0, step: 0.01
        }
    ],
};
const uShapeSegment = (radius, length) => Segments([[-radius, -length]], [[-radius, 0], undefined, [0, radius * CIRCULAR_RATIO]], [[0, radius], [-radius * CIRCULAR_RATIO, 0], [radius * CIRCULAR_RATIO, 0]], [[radius, 0], [0, radius * CIRCULAR_RATIO]], [[radius, -length]]);
